import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatDetail } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  async function submit(e) {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("ithaca_token", data.token);
      localStorage.setItem("ithaca_email", data.email);
      nav("/admin");
    } catch (e) {
      setErr(formatDetail(e.response?.data?.detail));
    } finally { setLoading(false); }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-stone_white">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="overline">Owner access</div>
          <h1 className="font-serif text-5xl mt-4 font-light">Ithaca Garden Villa</h1>
          <p className="text-ionian/60 mt-2 text-sm">Manage bookings, availability & pricing.</p>
        </div>
        <form onSubmit={submit} className="border border-soft_border bg-white p-10 space-y-8">
          <div>
            <div className="overline mb-1">Email</div>
            <input data-testid="admin-email" required type="email" value={email} onChange={e=>setEmail(e.target.value)} className="editorial-input w-full" />
          </div>
          <div>
            <div className="overline mb-1">Password</div>
            <input data-testid="admin-password" required type="password" value={password} onChange={e=>setPassword(e.target.value)} className="editorial-input w-full" />
          </div>
          {err && <div data-testid="admin-error" className="text-sm text-terracotta">{err}</div>}
          <button data-testid="admin-submit" type="submit" disabled={loading} className="btn-ionian w-full py-3 rounded-full text-sm uppercase tracking-widest disabled:opacity-50">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
